import uuidv4 from 'uuid/v4';

import * as service from '@/sitecore/sitecore-data-service';
import { Rendering } from '@/data/data-models';
import { processDataSources } from '@/sitecore/sitecore-data-interface';
import flexDeepCopy from '@/utils/flex-deep-copy';
import store from '@/store/store';
import { SET_HOLD_EVENTS } from '@/store/types/mutation-types';

export async function fetchRendering(componentItemId) {
    const response = await service.getComponent(componentItemId);

    if (response.status === 'error') {
        console.error(`Error getting data for component ID "${ componentItemId }": ${ response.error }`);
        return;
    }

    return processDataSources([response.data])[0];
}

export async function generateRendering(data, index = 0) {
    let componentItemID = '';
    let isSharedContent = false;
    let rendering = null;
    const isTemplateScreen = document.location.pathname.startsWith('/templates');

    if (data.props) {
        componentItemID = data.props.componentItemID;
        isSharedContent = data.props.isSharedContent;
    }

    // if a componentItemID is present, then this is a data-driven component
    if (componentItemID) {
        const response = await service.getComponent(componentItemID);
        rendering = processDataSources([response.data])[0];
        rendering = flexDeepCopy(rendering); // needed so we can replace the Sitecore IDs with "fake" ones
        rendering.linkedComponent = componentItemID;
        rendering.displayName = rendering.editorName;
        rendering.renderingField = isTemplateScreen ? 'shared' : 'final';
        rendering.dataSourceId = '00000000-0000-0000-0000-000000000000'; // none needed for new, will be generated in sitecore

        if (isSharedContent) {
            rendering.globalContent = true;
        } else {
            rendering.lockComponent = true;
        }
    } else {
        const pointer = index + 1;

        rendering = new Rendering({
            id: uuidv4(),
            renderingName: 'Organism',
            dataSourceId: '00000000-0000-0000-0000-000000000000', // none needed for new, will be generated in sitecore
            name: `${ data.name }_${ pointer }`,
            elementType: data.name,
            pointer,
            classes: '',
            elements: [],
            renderingField: isTemplateScreen ? 'shared' : 'final',
            props: data.props,
        });
    }
    if (store.state.page.holdEvents) {
        store.commit(SET_HOLD_EVENTS, false);
    }

    return rendering;
}
